import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

export const useCustomerStripeIdUpdate = (customerId: any) => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const updateCustomerStripeId = async (stripe_customer_id: any) => {
    return patch(`/management/customers/${customerId}/stripeId`, { stripe_customer_id })
  }

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: updateCustomerStripeId,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
    },
    onError: async (err: any) => {
      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
      const { error } = err.body || {}
      addNotification(`Error while updating customer stripe Id. ${error}`, 'error')
    },
  })

  return {
    update: mutateAsync,
    ...rest,
  }
}
